/* BOGOS "Congratulations" toast, site-wide.
   1. Rewrites the copy: "Congratulations! You got $8.00 off!" -> "Discount applied" / "$8.00 off your order."
   2. Shows it once per discount amount per visit. The app re-shows it on every page load while the cart
      holds a discount; here it only appears again if the discount amount changes. */
(function () {
  var KEY = "magsi-bogos-toast-seen";

  function read() {
    try { return window.sessionStorage.getItem(KEY); } catch (e) { return null; }
  }
  function write(value) {
    try { window.sessionStorage.setItem(KEY, value); } catch (e) { /* storage blocked: fall back to showing it */ }
  }

  function leaf(root, test) {
    var hit = null;
    root.querySelectorAll("*").forEach(function (el) {
      if (!hit && !el.children.length && test(el.textContent)) hit = el;
    });
    return hit;
  }

  function tidyToast(root) {
    if (root.dataset.magsi) return;

    var header = root.querySelector(".bogos-cart-discount-congrats-header");
    var desc = root.querySelector(".bogos-cart-discount-congrats-description");
    if (!header || !desc) return;

    var amount = (desc.textContent.match(/\$[\d.,]+/) || [""])[0];
    var title = leaf(header, function (t) { return /congrat/i.test(t); });

    /* Not the message we expect: leave the app's copy alone, just show it. */
    if (!title || !amount) { root.dataset.magsi = "1"; return; }

    /* Same discount already shown this visit: keep it hidden. */
    if (read() === amount) { root.dataset.magsi = "hide"; return; }
    write(amount);

    title.textContent = "Discount applied";
    desc.textContent = amount + " off your order.";
    /* drop the party emoji if it sits in its own element */
    header.querySelectorAll("*").forEach(function (el) {
      if (!el.children.length && el !== title && el.textContent.trim() && !/[A-Za-z0-9]/.test(el.textContent)) {
        el.style.display = "none";
      }
    });
    root.dataset.magsi = "1";
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll(".bogos-cart-discount-congrats-container").forEach(tidyToast);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
